import React, { Component } from 'react'
import { connect } from 'react-redux';

import GDPRModal from './GDPRModal'
import './GDPR.scss'
import { changeMenuTitleHeader } from 'actions/Menu'
import { fetchingTermsConditions, fetchingPrivacyPolicy } from 'actions/Gdpr'

class Gdpr extends Component {

  state = {
    showModal: false,
    isTermsConditions: true
  }

  constructor(props) {
    super(props)
    this.escFunction = this.escFunction.bind(this);
  }

  componentDidMount() {
    this.props.onChangeTitleHeader('GDPR Info')
    this.props.onFetchingTermsConditions()
    this.props.onFetchingPrivacyPolicy()
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.setState({ showModal: false })
    }
  }

  handleOpenTermsConditions = () => {
    this.setState({ showModal: true, isTermsConditions: true })
  }

  handleOpenPrivacyPolicy = () => {
    this.setState({ showModal: true, isTermsConditions: false })
  }

  handleCloseModal = () => {
    this.setState({ showModal: false })
  }

  render() {
    return (
      <div className="main-content">
        <div className="list-items gdpr-content">
          <GDPRModal
            style={{ top: '5%', right: '5%', height: '450px', width: '85%', overflow: 'hidden' }}
            show={this.state.showModal}
            termsConditions={this.props.termsConditions}
            privacyPolicy={this.props.privacyPolicy}
            closeModal={this.handleCloseModal}
            isTermsConditions={this.state.isTermsConditions} />
          <div className="gdpr-terms-conditions">
            <a target="_blank" onClick={this.handleOpenTermsConditions}>Terms and Conditions</a>
          </div>
          <div className="gdpr-privacy-policy">
            <a target="_blank" onClick={this.handleOpenPrivacyPolicy}>Privacy Policy</a>
          </div>
        </div>
      </div>)
  }
}

const mapStateToProps = state => {
  return {
    termsConditions: state.gdprReducer.termsConditions,
    privacyPolicy: state.gdprReducer.privacyPolicy
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeTitleHeader: titleHeader => dispatch(changeMenuTitleHeader(titleHeader)),
    onFetchingTermsConditions: () => dispatch(fetchingTermsConditions()),
    onFetchingPrivacyPolicy: () => dispatch(fetchingPrivacyPolicy()),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Gdpr)



// WEBPACK FOOTER //
// ./src/containers/GDPR/index.js